import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const loadMe = () => api.get("/auth/me").then((r) => setUser(r.data));

  useEffect(() => {
    localStorage.removeItem("zds_token");
    loadMe().catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    await loadMe();
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const isAdmin = user?.role === "admin";
  const can = (module, action = "view") => !!user && (user.permissions === null || !!user.permissions?.[module]?.[action]);

  return <AuthContext.Provider value={{ user, login, logout, can, isAdmin, reloadUser: loadMe }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
